/** @file drawText: writes a line of text into an image with the 3x5 TINY_FONT, scaled by whole pixels. */
import { fillRect } from '../image/fillRect';
import type { Image, Rgba } from '../types/image';
import { TINY_FONT } from './tinyFont';

/** Plots one glyph's ink at (`x`, `y`), each font pixel a `scale` x `scale` block. */
function glyph(dst: Image, rows: string, x: number, y: number, color: Rgba, scale: number): void {
  rows.split(' ').forEach((row, j) => {
    for (let i = 0; i < row.length; i++) if (row[i] === '#') fillRect(dst, x + i * scale, y + j * scale, scale, scale, color);
  });
}

/**
 * Draws `text` (case folded; characters the font lacks print as `?`) with its top-left at (`x`, `y`), clipped to the
 * image, and returns the width it took: `4 * scale` per character minus the trailing gap.
 */
export function drawText(dst: Image, text: string, x: number, y: number, color: Rgba, scale = 1): number {
  const chars = Array.from(text.toLowerCase());
  chars.forEach((c, k) => { glyph(dst, TINY_FONT[c] ?? TINY_FONT['?'] ?? '', x + k * 4 * scale, y, color, scale); });
  return Math.max(0, chars.length * 4 * scale - scale);
}
